
  import { defineComponent, PropType } from 'vue';

  import { getRuCurrentDateWithFullMonth } from '@/common/utils/dates';
  import { getCurrentYear } from '@/common/utils/year';

  import { TBaseRegionFilter } from '@/modules/ves/types/common';
  import { TDashboardMainFilter } from '@/modules/ves/types/dashboards';

  import { ALL_YEAR_OPTION } from '../../constants/dashboards';
  import { getDashboardsYearsOptions, getIsIncludeYear } from '../../utils/years';

  export default defineComponent({
    name: 'DateActualDataSubtitle',
    props: {
      filter: {
        type: Object as PropType<Partial<TDashboardMainFilter & TBaseRegionFilter>>,
        required: true,
      },
      isOnceYear: {
        type: Boolean,
        required: false,
        default: false,
      },
      isSimpleYearLabel: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      getCurrentDate() {
        return getRuCurrentDateWithFullMonth();
      },

      getPeriods() {
        const options = getDashboardsYearsOptions();
        const filterYear = this.filter?.year ?? '';
        const isIncludeYear = getIsIncludeYear(options, filterYear);

        const isFutureYear = Number(filterYear) > getCurrentYear();
        const isKnownYear = isIncludeYear || isFutureYear;

        if (!isKnownYear && !this.isOnceYear) {
          return `с ${options[0].label} по ${options[options.length - 1].label} годы`;
        }

        const year = !isKnownYear && this.isOnceYear ? options[options.length - 1].label : filterYear;

        return `за ${year} год`;
      },

      subtitleText(): string {
        const year = this.filter?.year;
        if (
          this.isSimpleYearLabel &&
          year &&
          Number(year) < new Date().getFullYear() &&
          year !== ALL_YEAR_OPTION.value
        ) {
          return `Данные за ${year} год`;
        }
        return `Данные ${this.getPeriods} по состоянию на ${this.getCurrentDate} года`;
      },
    },
  });
